export const courseDetailPageEventConfig = {
  name: "testimonials-module",
  htmlId: "testimonials-module",
  location: "detail-page",
  elementType: "testimonials-module",
};
